import { Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import {
    TestProjectInputEditorContent,
    TestProjectInputEditorActions,
    getTestProjectInputEditorTitle
} from './TestProjectInputEditorPresentation';
import type { TestProjectInputDialogProps } from './types';

type Props = TestProjectInputDialogProps & { onMapInputs: () => void };

const TestProjectInputEditDialog: React.FC<Props> = ({ store, draft, onMapInputs }) => {
    return (
        <>
            <Modal
                visible
                title={getTestProjectInputEditorTitle(draft, false)}
                onCancel={store.close}
                maskClosable={false}
                closable={!store.isSubmitting}
                keyboard={!store.isSubmitting}
                centered
                destroyOnClose
                width={850}
                footer={
                    <TestProjectInputEditorActions
                        store={store}
                        draft={draft}
                        onMapInputs={onMapInputs}
                        onCancel={store.close}
                        confirmation={false}
                    />
                }
            >
                <TestProjectInputEditorContent store={store} draft={draft} confirmation={false} />
            </Modal>
            {draft.showsConfirmation && (
                <Modal
                    visible
                    title={getTestProjectInputEditorTitle(draft, true)}
                    onCancel={store.cancelEditing}
                    maskClosable={false}
                    closable={!store.isSubmitting}
                    keyboard={!store.isSubmitting}
                    centered
                    footer={
                        <TestProjectInputEditorActions
                            store={store}
                            draft={draft}
                            onMapInputs={onMapInputs}
                            onCancel={store.close}
                            confirmation
                        />
                    }
                >
                    <TestProjectInputEditorContent store={store} draft={draft} confirmation />
                </Modal>
            )}
        </>
    );
};

export default observer(TestProjectInputEditDialog);
